import { AllocateFundsStoreProps } from "@ctypes";
import { useAllocateFundsStore } from "@stores";

export const useAllocateFundsFlow = () => {
  const { allocateFundsProps, setAllocateFundsProps: setAllocateFundsPropsFromStore } =
    useAllocateFundsStore();

  const setAllocateFundsProps = (newAllocateFundsProps: AllocateFundsStoreProps) => {
    setAllocateFundsPropsFromStore({
      ...allocateFundsProps,
      ...newAllocateFundsProps,
    });
  };

  const clearAllocateFundsProps = () => {
    setAllocateFundsPropsFromStore({});
  };

  const resetAllocateFundsProps = (newAllocateFundsProps: AllocateFundsStoreProps) => {
    setAllocateFundsPropsFromStore(newAllocateFundsProps);
  };

  return {
    allocateFundsProps,
    setAllocateFundsProps,
    clearAllocateFundsProps,
    resetAllocateFundsProps,
  };
};
